/* FizzyIQ — Science "Support That Fits Real Life" band reveal. Adds .reveal so
   the content starts hidden (only when JS runs — no-JS keeps it visible), then
   .in-view when the band scrolls into view to play the staggered fade-up. */
(function () {
  function boot() {
    var els = document.querySelectorAll('.scsup');
    if (!els.length) return;
    els.forEach(function (el) {
      el.classList.add('reveal');
      if (!('IntersectionObserver' in window)) { el.classList.add('in-view'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { el.classList.add('in-view'); io.disconnect(); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
